// src/redux/localStorage.ts
export function loadState<T = any>(): T | undefined {
  if (typeof window === "undefined") return undefined; // SSR-safe
  try {
    const raw = window.localStorage.getItem("__app_state__");
    return raw ? (JSON.parse(raw) as T) : undefined;
  } catch {
    return undefined;
  }
}

export function saveState<T = any>(state: T) {
  if (typeof window === "undefined") return; // SSR-safe
  try {
    window.localStorage.setItem("__app_state__", JSON.stringify(state));
  } catch {
    // ignore quota/private-mode errors
  }
}

// Use global setTimeout (works in SSR & browser)
export function throttle<T extends (...args: any[]) => void>(
  fn: T,
  ms: number
) {
  let last = 0;
  let timer: ReturnType<typeof setTimeout> | null = null;

  return (...args: Parameters<T>) => {
    const now = Date.now();
    const remain = ms - (now - last);

    if (remain <= 0) {
      last = now;
      fn(...args);
    } else if (!timer) {
      timer = setTimeout(() => {
        last = Date.now();
        timer = null;
        fn(...args);
      }, remain);
    }
  };
}
